import React, { Component } from 'react';
import { apiPost, apiGet } from '../../Api';
import AdminAPI from './AdminAPI';

export default class StatDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            imagePreviewUrl: '',
            stat: null
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.statId !== prevProps.statId || this.props.creatingNewStat !== prevProps.creatingNewStat) {
            this.setState({ imageFile: null, imagePreviewUrl: null });

            this.getStat();

        }
    }


    getStat = async () => {
        if (this.props.statId != null) {
            if (this.props.statId === "") {
                // this.setState({ stat: null });
                this.setState({ stat: { name: "", shortName: "", flavourText: "", orderIndex: 100, imageId: "" }, imageFile: null, imagePreviewUrl: "" });
            }
            else {
                const response = await apiGet("/stat/" + this.props.statId);
                if (response.ok) {
                    const curr = await response.json();
                    this.setState({ stat: curr });
                    if (curr.imageId) {
                        this.fetchImage();
                    }
                }
            }
        }
        else {
            this.setState({ stat: null });
        }
    }

    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }

        if (event.target.type === "select-one") {

            value = Number(event.target.value);
            if (isNaN(value)) {
                value = event.target.value;
            }
        }

        const stat = { ...this.state.stat, [name]: value };
        this.setState({ stat });
    };

    handleImageChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                imageFile: file,
                imagePreviewUrl: reader.result
            });
            this.handleUpload();

        };

        reader.readAsDataURL(file);


    };

    handleUpload = async () => {
        const file = this.state.imageFile;
        const formData = new FormData();
        formData.append('files', file);

        // Modify the URL to point to your server endpoint
        const url = '/Image';

        try {
            const response = await apiPost(url, formData, true);

            if (response.ok) {
                console.log('File uploaded successfully');
                var resp = await response.json();
                // this.props.onChange(onChange={e => stat.shortname = e.target.value})

                const stat = { ...this.state.stat, imageId: resp.id };
                this.setState({ stat });
            } else {
                console.error('Error uploading file:', await response.text());
            }
        } catch (error) {
            console.error('Network error:', error);
        }
    };

    fetchImage = async () => {
        try {
            const objectURL = await AdminAPI.fetchImage(this.state.stat?.imageId);
            this.setState({ imagePreviewUrl: objectURL });
        } catch (error) {
            console.error('Error fetching image:', error);
        }
    };

    handleImageChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                imageFile: file,
                imagePreviewUrl: reader.result
            });
            this.handleUpload();

        };

        reader.readAsDataURL(file);


    };


    render() {
        const { onUpdate, onDelete, onCreate, creatingNewStat, onCancelCreate, procTypes, enemyTypes, damageTypes, procEventTypes } = this.props;
        const { stat, imagePreviewUrl } = this.state;

        if (!stat || stat == null) return <div>Select a stat to see details</div>;
        console.log(stat.procType);
        return (
            <div className='admin_details'>
                <label>Name:
                    <input type="text" name="name" value={stat.name} onChange={this.handleInputChange} />
                </label>

                <label className='labelBackground1'>
                    StatType:
                    <select
                        name="statType"
                        value={stat.statType ? stat.statType : ""}
                        onChange={this.handleInputChange}
                    >

                        <option key={0} value={0}>Stat</option>
                        <option key={1} value={1}>Proc</option>
                    </select>
                </label>

                <label>
                    Has Range (from/to):
                    <input type="checkbox" name="hasRange" checked={stat.hasRange !== false} onChange={this.handleInputChange} />
                </label>


                <label className='labelBackground2'>
                    DamageType:
                    <select
                        name="damageType"
                        value={stat.damageType ? stat.damageType : ""}
                        onChange={this.handleInputChange}
                    >
                        <option key="" value=""></option>
                        {damageTypes.map((obj, index) =>
                            <option key={index} value={obj.id}>{obj.name}</option>
                        )}

                    </select>
                </label>
                <label>Image:
                    <input type="file" onChange={this.handleImageChange} />
                    {imagePreviewUrl && <img src={imagePreviewUrl} alt="Preview" className='adminPreviewImage' />}
                </label>
                <label>FlavourText:
                    <textarea type="text" name="flavourText" value={stat.flavourText} onChange={this.handleInputChange} />
                </label>

                <label>UnitSymbol:
                    <input type="text" name="unitSymbol" value={stat.unitSymbol} onChange={this.handleInputChange} />
                </label>

                {creatingNewStat ?
                    <div>
                        {/* Form to create a new stat, similar to the update form... */}
                        <button onClick={() => onCreate(stat)}>Create</button>
                        <button onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button onClick={() => onUpdate(stat)}>Update</button>
                        <button onClick={() => onDelete(stat)}>Delete</button>
                    </div>
                }


            </div>
        );


    }

}
